self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "public/build/";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^(http:)|(https:)|(file:)/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              var js = '/*' + label + '*/importScripts("' + result + '");';
              return 'data:text/javascript;charset=utf-8,' + encodeURIComponent(js);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "monaco-editor.worker.js",
  "json": "monaco-json.worker.js",
  "html": "monaco-html.worker.js",
  "handlebars": "monaco-html.worker.js",
  "razor": "monaco-html.worker.js"
});
require("./contrib/bracketMatching/bracketMatching.js");
require("./contrib/caretOperations/caretOperations.js");
require("./contrib/folding/folding.js");
require("./contrib/parameterHints/parameterHints.js");
require("./contrib/suggest/suggestController.js");
module.exports = require("!!./editor.api.js");
require("../language/json/monaco.contribution.js");
require("../basic-languages/markdown/markdown.contribution.js");
require("../basic-languages/html/html.contribution.js");
require("../language/html/monaco.contribution.js");
require("../basic-languages/sql/sql.contribution.js");
require("../basic-languages/mysql/mysql.contribution.js");
require("../basic-languages/pgsql/pgsql.contribution.js");
require("../basic-languages/javascript/javascript.contribution.js");